import styled from 'styled-components';

import Logo from '../../assets/prosper-logo.svg';

// Pink/orange Prosper logo

const ProsperLogo = styled(Logo)`
  height: 1.3125rem;
  width: auto;
`;
ProsperLogo.displayName = 'ProsperLogo';

export default ProsperLogo;
